import axios from 'axios';
import {
  takeEvery, call, put, all,
} from 'redux-saga/effects';
import { toast } from 'react-toastify';
import firebase from '../../firebase';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';
import * as types from '../types';

function* sendMessage(action) {
  try {
    const sendMsg = payload => axios.post(
      'https://us-central1-ahapte-vet.cloudfunctions.net/sendMessage',
      {
        treatmentId: payload.treatmentId,
        phoneM1: payload.phoneM1 || null,
        phoneM2: payload.phoneM2 || null,
        text: payload.text,
        petName: payload.petName,
        petId: payload.petId,
      },
    );

    yield call(sendMsg, action.payload);

    yield put({
      type: types.SEND_SMS_SUCCESS,
    });

    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
    yield call(toast.success, 'Message sent');
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.SEND_SMS_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}

function* sendEmail(action) {
  const sendFirstMail = payload => axios.post(
    'https://us-central1-ahapte-vet.cloudfunctions.net/sendMail',
    {
      petId: payload.petId,
      treatmentId: payload.treatmentId,
      email: payload.email1,
      vaccination: payload.vaccination,
      petName: payload.petName,
    },
  );

  const sendSecondMail = payload => axios.post(
    'https://us-central1-ahapte-vet.cloudfunctions.net/sendMail',
    {
      petId: payload.petId,
      treatmentId: payload.treatmentId,
      email: payload.email2,
      vaccination: payload.vaccination,
      petName: payload.petName,
    },
  );

  try {
    if (action.payload.email1 && action.payload.email1 !== '') {
      yield call(sendFirstMail, action.payload);
    }

    if (action.payload.email2 && action.payload.email2 !== '') {
      yield call(sendSecondMail, action.payload);
    }

    yield put({
      type: types.SEND_EMAIL_SUCCESS,
    });

    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }

    yield call(toast.success, 'Message sent');
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.SEND_EMAIL_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}

function* getTreatmentData(action) {
  try {
    const db = firebase.firestore();
    const tempQuery = db.collection('pets').doc(action.payload.petId).collection('treatments').doc(action.payload.treatmentId);

    const response = yield call(
      [tempQuery, tempQuery.get],
    );

    yield put({
      type: types.GET_TREATMENT_DATA_SUCCESS,
      payload: {
        treatmentData: response.data(),
      },
    });

    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
    yield call(toast.success, 'Got treatment details');
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.GET_TREATMENT_DATA_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}


function* getPetTreatments(action) {
  try {
    const db = firebase.firestore();
    const tempQuery = db.collection('pets').doc(action.payload.id).collection('treatments').orderBy('date', 'desc');

    const petTreatmentList = [];
    const precautionList = [];

    const querySnapshot = yield call(
      [tempQuery, tempQuery.get],
    );

    yield all(querySnapshot.docs.map((doc) => {
      // Form precautionList array from precautions of treatments
      if (doc.data().precaution) {
        precautionList.push({
          id: doc.id,
          date: doc.data().date,
          precaution: doc.data().precaution,
        });
      }

      // Load all treatment data in array
      return petTreatmentList.push({
        id: doc.id,
        date: doc.data().date,
        symptoms: doc.data().symptoms,
        diagnosis: doc.data().diagnosis,
        treatment: doc.data().treatment,
        vaccination: doc.data().vaccination,
        deworming: doc.data().deworming,
        amount: doc.data().amount,
        note: doc.data().note,
        weight: doc.data().weight,
        reports: doc.data().reports,
        sentSms: doc.data().sentSms || false,
        sentEmail: doc.data().sentEmail || false,
      });
    }));

    yield put({
      type: types.GET_SINGLE_PET_TREATMENTS_SUCCESS,
      payload: {
        petTreatmentList,
        precautionList,
      },
    });

    yield call(toast.success, 'Got all treatments for pet');
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.GET_SINGLE_PET_TREATMENTS_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}

function* addSingleTreatment(action) {
  const temp = action.payload.values;

  // get reports file list (type File)
  const reports = action.meta.fileList;

  // remove unnecessary reports present in values to be added
  delete temp.reports;

  try {
    const db = firebase.firestore();
    const tempQuery = db.collection('pets').doc(action.payload.id).collection('treatments');

    // Add treatment data without reports
    const response = yield call(
      [tempQuery, tempQuery.add],
      temp,
    );

    const treatmentId = response.id;
    const storageRef = firebase.storage().ref();

    // If attached reports are present
    if (reports) {
      for (let i = 0; i < reports.length; i += 1) {
        // Folder name is the id of treatment, and name would be same to file name
        const reportFolderRef = storageRef.child(`${treatmentId}/${reports[i].name}`);
        const file = reports[i];

        // Store file in firebase cloud storage
        yield call(
          [reportFolderRef, reportFolderRef.put],
          file,
        );

        // Get downloadurl of individual file after storage
        const resp2 = yield call(
          [reportFolderRef, reportFolderRef.getDownloadURL],
        );

        // get file name (i) here at the moment and store it in an array
        // in reports parameter of treatment

        // query to access previously created treatment
        const tempQuery1 = db.collection('pets').doc(action.payload.id).collection('treatments').doc(treatmentId);

        // Add reference to previously created treatment record in firestore
        const check = {
          reports: firebase.firestore.FieldValue.arrayUnion(
            `${resp2}`,
          ),
        };

        // Store the downloadUrl array
        yield call(
          [tempQuery1, tempQuery1.update],
          check,
        );
      }
    }

    yield put({
      type: types.ADD_SINGLE_TREATMENT_SUCCESS,
    });

    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
    yield call(toast.success, 'Added treatment');
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.ADD_SINGLE_TREATMENT_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}


function* editSingleTreatment(action) {
  // get reports file list
  const reports = action.meta.fileList;

  const temp = action.payload.values;
  // remove unnecessary reports present in values to be added
  delete temp.reports;

  const deletedFiles = action.payload.deletedFileArray;

  try {
    const db = firebase.firestore();
    const tempQuery = db.collection('pets').doc(action.payload.petId).collection('treatments').doc(action.payload.treatmentId);

    yield call(
      [tempQuery, tempQuery.update],
      temp,
    );
    const storageRef = firebase.storage().ref();

    if (deletedFiles) {
      for (let i = 0; i < deletedFiles.length; i += 1) {
        const check = {
          reports: firebase.firestore.FieldValue.arrayRemove(
            `${deletedFiles[i]}`,
          ),
        };

        yield call(
          [tempQuery, tempQuery.update],
          check,
        );

        const reportFolderRef = storageRef.child(`${action.payload.treatmentId}/${deletedFiles[i].split('%2F')[1].split('?alt')[0]}`);

        yield call(reportFolderRef.delete);
      }
    }

    if (reports) {
      for (let i = 0; i < reports.length; i += 1) {
        // Folder name is the id of treatment, and name would be same to file name
        const reportFolderRef = storageRef.child(`${action.payload.treatmentId}/${reports[i].name}`);
        const file = reports[i];

        // Store file in firebase cloud storage
        yield call(
          [reportFolderRef, reportFolderRef.put],
          file,
        );

        const resp2 = yield call(
          [reportFolderRef, reportFolderRef.getDownloadURL],
        );

        // get file name (i) here at the moment and store it in an array in
        // reports parameter of treatment
        // const db = firebase.firestore();

        // query to access previously created treatment

        // Add reference to previously created treatment record in firestore
        const check = {
          reports: firebase.firestore.FieldValue.arrayUnion(
            `${resp2}`,
          ),
        };

        yield call(
          [tempQuery, tempQuery.update],
          check,
        );
      }
    }

    yield put({
      type: types.ADD_SINGLE_TREATMENT_SUCCESS,
    });

    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
    yield call(toast.success, 'Added treatment');
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.ADD_SINGLE_TREATMENT_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}


function* deleteTreatment(action) {
  // get reports file list
  const { reports } = action.payload;

  // remove unnecessary reports present in values to be added

  try {
    const db = firebase.firestore();
    const tempQuery = db.collection('pets').doc(action.payload.petId).collection('treatments').doc(action.payload.treatmentId);

    yield call(
      [tempQuery, tempQuery.delete],
    );
    const storageRef = firebase.storage().ref();

    if (reports) {
      yield all(reports.map(report => storageRef.child(`${action.payload.treatmentId}/${report.split('%2F')[1].split('?alt')[0]}`).delete()));
    }
    yield put({
      type: types.DELETE_TREATMENT_SUCCESS,
    });

    if (action.meta.onSuccess) {
      yield call(action.meta.onSuccess);
    }
    yield call(toast.success, 'Deleted treatment successfully');
  } catch (err) {
    console.log('error');
    console.log(err);
    yield put({
      type: types.DELETE_TREATMENT_FAILURE,
    });
    yield call(toast.error, err.message);
  }
}
export default function* () {
  yield takeEvery(types.GET_SINGLE_PET_TREATMENTS_REQUEST, getPetTreatments);
  yield takeEvery(types.SEND_SMS_REQUEST, sendMessage);
  yield takeEvery(types.SEND_EMAIL_REQUEST, sendEmail);
  yield takeEvery(types.ADD_SINGLE_TREATMENT_REQUEST, addSingleTreatment);
  yield takeEvery(types.EDIT_TREATMENT_DATA_REQUEST, editSingleTreatment);
  yield takeEvery(types.GET_TREATMENT_DATA_REQUEST, getTreatmentData);
  yield takeEvery(types.DELETE_TREATMENT_REQUEST, deleteTreatment);
}
